module.exports = __webpack_public_path__ + "media/images/block_link-aff05d2609efa75c3945cb18ba6910e0.svg";